export default __webpack_public_path__ + "static/media/Bandipur2.90b55da7.jpg";